import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { ArrowUpRight, Award, BookOpen, Clock, Lock } from "lucide-react";

export default function TeacherTraining() {
  const [courses, setCourses] = useState([]);
  useEffect(() => { api.get("/courses", { params: { category: "teacher_training" } }).then((r) => setCourses(r.data)).catch(() => {}); }, []);

  return (
    <div>
      <section className="grain bg-ink text-rice">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20">
          <span className="label text-gold">Chinese Language Pedagogy</span>
          <h1 className="font-serif font-light text-5xl sm:text-6xl lg:text-7xl tracking-tighter mt-5 text-rice max-w-3xl">
            Train to teach Mandarin — the <span className="italic text-gold">Indian classroom</span> way.
          </h1>
          <p className="text-rice/60 mt-6 max-w-2xl text-lg">
            Purpose-built pedagogy training for Indian teachers who want to teach Chinese with structure,
            confidence and cultural sensitivity.
          </p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 lg:px-10 py-20 grid md:grid-cols-2 gap-8">
        {courses.map((c) => (
          <div key={c.course_id} className="border border-black/10 bg-white p-8 flex flex-col" data-testid={`tt-card-${c.slug}`}>
            <div className="flex items-center gap-3 text-cinnabar mb-4">
              <BookOpen size={22} />
              <span className="label text-gold">{c.level}</span>
            </div>
            <h3 className="font-serif text-3xl">{c.title}</h3>
            {c.format && <p className="text-xs text-clay mt-2 font-mono flex items-center gap-1.5"><Clock size={12} /> {c.duration} · {c.hours} · {c.format}</p>}
            <p className="text-clay mt-4 leading-relaxed flex-1">{c.description}</p>
            <ul className="mt-6 space-y-2 text-sm text-clay">
              {c.syllabus.slice(0, 5).map((s, i) => <li key={i} className="border-l-2 border-cinnabar/40 pl-3">{s}</li>)}
            </ul>
            <div className="mt-8 flex items-center justify-between">
              <div>
                <p className="font-display font-extrabold text-2xl text-ink">₹{c.price_inr.toLocaleString("en-IN")}</p>
                <p className="text-xs text-clay">{c.duration}</p>
              </div>
              <Link to={`/courses/${c.slug}`} data-testid={`tt-course-${c.slug}`}
                className="inline-flex items-center gap-2 px-6 py-3 bg-ink text-rice text-sm hover:bg-cinnabar transition-colors duration-300">
                Details <ArrowUpRight size={16} />
              </Link>
            </div>
          </div>
        ))}

        {/* Diploma — coming soon */}
        <div className="border border-dashed border-black/20 bg-rice p-8 flex flex-col" data-testid="tt-diploma-soon">
          <div className="flex items-center gap-3 text-clay mb-4">
            <Award size={22} />
            <span className="label text-clay">Diploma · Coming Soon</span>
          </div>
          <h3 className="font-serif text-3xl text-ink/70">Diploma in Chinese Language Pedagogy</h3>
          <p className="text-clay mt-4 leading-relaxed flex-1">
            An advanced diploma for professional Chinese teachers — building on the certificate with deeper methodology,
            curriculum design and a supervised teaching project. Launching soon.
          </p>
          <div className="mt-8 inline-flex items-center gap-2 px-6 py-3 border border-black/15 text-clay text-sm w-fit">
            <Lock size={15} /> Notify me — <Link to="/contact" className="text-cinnabar hover:underline ml-1">Register interest</Link>
          </div>
        </div>
      </section>
    </div>
  );
}
